/**
 * Formats a date string or Date object to "yyyy-mm-dd hh:MM:ss" format in local time
 * Uses monospace font styling for consistent alignment
 */
export function formatDateTime(
  dateInput: string | Date | null | undefined
): string {
  if (!dateInput) return 'N/A'

  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput

  // Check if date is valid
  if (isNaN(date.getTime())) return 'Invalid Date'

  const year = date.getFullYear().toString().padStart(4, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}
